import { Dashboard } from '../dashboard';
import s from './dashboard-reviews.module.css';
import { useDashboardReviews } from './use-dashboard-reviews';

export const DashboardReviews = () => {
  const { chartData } = useDashboardReviews();

  return <Dashboard chartsData={chartData} dashboardsClassname={s.feature} />;
};
